var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTyreWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00014 11.8301C4.32264 11.8301 2.17014 9.66011 2.17014 7.00014C2.17014 4.32264 4.34017 2.17014 7.00014 2.17014C9.66017 2.17014 11.8301 4.32261 11.8301 7.00014C11.8301 9.67767 9.67767 11.8301 7.00014 11.8301M7 0C3.1325 0 0 3.1325 0 7C0 10.8675 3.1325 14 7 14C10.8675 14 14 10.8675 14 7C14 3.1325 10.8675 0 7 0",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99747 8.40034C6.22744 8.40034 5.59744 7.77034 5.59744 7.00031C5.59744 6.23027 6.22744 5.60027 6.99747 5.60027C7.7675 5.60027 8.3975 6.23027 8.3975 7.00031C8.3975 7.77034 7.7675 8.40034 6.99747 8.40034V8.40034ZM11.3558 6.66796C11.3033 5.95043 11.0757 5.26793 10.7083 4.69043C9.97328 5.60046 8.85331 5.91539 8.15322 5.40796C7.43569 4.88293 7.40078 3.72789 8.03066 2.74793C7.69813 2.67799 7.34816 2.62549 6.99819 2.62549C6.64822 2.62549 6.29825 2.67799 5.96572 2.74805C6.59572 3.72802 6.56069 4.88305 5.84316 5.40808C5.12563 5.93311 4.00563 5.60058 3.28809 4.69055C2.92053 5.26805 2.69313 5.95055 2.64062 6.66808C3.76063 6.37058 4.86316 6.77305 5.12563 7.59558C5.40566 8.43555 4.74063 9.39808 3.65566 9.81811C4.11063 10.3431 4.68813 10.7806 5.33572 11.0431C5.38822 9.88805 6.10575 8.96055 6.99819 8.96055C7.89063 8.96055 8.59072 9.88805 8.66066 11.0431C9.30813 10.7806 9.88563 10.3606 10.3407 9.81811C9.25575 9.39808 8.60819 8.43568 8.87075 7.59558C9.15066 6.77296 10.2358 6.37049 11.3558 6.66796Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85569 7.00011C7.85569 7.47373 7.47178 7.85764 6.99816 7.85764C6.52453 7.85764 6.14062 7.47373 6.14062 7.00011C6.14062 6.52648 6.52453 6.14258 6.99816 6.14258C7.47178 6.14258 7.85569 6.52648 7.85569 7.00011",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyreWhite);
export default __webpack_public_path__ + "static/media/tyre-white.94e193ae44efa8372e1ef0ee36a07458.svg";
export { ForwardRef as ReactComponent };